module.exports = __webpack_public_path__ + "img/usa-digestive-diseases-female.42d0daac.png";